export default function FucinoLogo({ src, className = "", testId = "fucino-logo" }) {
  return (
    <img
      data-testid={testId}
      className={className}
      src={src}
      alt="Fucino Pizza circular logo"
      loading="eager"
    />
  );
}
